var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.828125,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.828125,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#D2D6DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4852 22.587C11.5196 22.2768 11.5368 22.1218 11.5838 21.9768C11.6254 21.8483 11.6842 21.7259 11.7586 21.6131C11.8425 21.4859 11.9528 21.3756 12.1734 21.1549L22.0781 11.2502C22.9066 10.4218 24.2497 10.4218 25.0781 11.2502C25.9066 12.0787 25.9066 13.4218 25.0781 14.2502L15.1734 24.1549C14.9528 24.3756 14.8425 24.4859 14.7153 24.5698C14.6025 24.6442 14.4801 24.703 14.3515 24.7446C14.2066 24.7915 14.0515 24.8087 13.7414 24.8432L11.2031 25.1252L11.4852 22.587Z",
    stroke: "#0E5E84",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBuilding);
export default __webpack_public_path__ + "static/media/EditBuilding.033b2e6c0ca7071e3ba539f70990ff9e.svg";
export { ForwardRef as ReactComponent };